import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { getInfluencerLikeFromCompany, deleteLikeToInfluencers, postLikeToInfluencers } from "../../api/companyApi";
//import { deleteLikeToInfluencers, getCompanyLikeFromInfluencer, postLikeToInfluencers } from "../../api/influencerApi";
import { UserContext } from "../../context/userContext";
import { LikeInfluencerContainer } from "./LikeInfluencerStyled";

export default function LikeInfluencer({ profileId, isFavorite, setIsFavorite }) {

    const navigate = useNavigate();
    //const [isFavorite, setIsFavorite] = useState(false);

    const { companyId, userToken, userType } = useContext(UserContext);

    useEffect(() => {
        if (companyId !== -1) {
            getInfluencerLikeFromCompany({ companyId: companyId }).then((response) => {
                const likes = response
                const favorite = likes.some((element) => element.influincridlike
                    === profileId)
                setIsFavorite(favorite)
            })
        }
    }, [companyId, profileId])


    const handlerLike = () => {
        if (userToken === null) {
            navigate('/signin')
        } else {

            const likeBody = {
                deleted: "0",
                companyidlike: companyId,
                influincridlike: profileId
            }
            if (isFavorite) {
                deleteLikeToInfluencers({ companyId: companyId, influencerId: profileId }).then((response) => {

                    if (response.status === 204) {
                        setIsFavorite(false)
                    }

                })
            } else {

                postLikeToInfluencers({ likeBody: likeBody }).then((response) => {
                    if (response.status === 201) {
                        setIsFavorite(true)
                    }

                })
            }


        }
    }

    return (
        <LikeInfluencerContainer onClick={handlerLike}>

            <svg id="Grupo_307" data-name="Grupo 307" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="47.381" height="45.333" viewBox="0 0 47.381 45.333">
                <defs>
                    <clipPath id="clip-path">
                        <rect id="Rectángulo_94" data-name="Rectángulo 94" width="47.381" height="45.333" fill="none" />
                    </clipPath>

                    <linearGradient id="grad1" gradientTransform="rotate(110)">
                        <stop offset="10%" stop-color="#f4a540" />
                        <stop offset="25%" stop-color="#ed5340" />
                        <stop offset="55%" stop-color="#e54182" />
                        <stop offset="70%" stop-color="#6643d7" />
                    </linearGradient>

                </defs>
                <g id="Grupo_269" data-name="Grupo 269" clip-path="url(#clip-path)">
                    {(isFavorite) ? (<path id="Trazado_12" data-name="Trazado 12" d="M39.1,42.631l-2.07-12.318a2.314,2.314,0,0,1,.672-2.046l8.974-8.688A2.314,2.314,0,0,0,45.4,15.627L33.05,13.789a2.314,2.314,0,0,1-1.738-1.272L25.822,1.3a2.314,2.314,0,0,0-4.15-.014L16.106,12.466a2.315,2.315,0,0,1-1.747,1.26L1.992,15.48A2.314,2.314,0,0,0,.7,19.423l8.915,8.749a2.314,2.314,0,0,1,.659,2.051l-2.153,12.3a2.314,2.314,0,0,0,3.349,2.451L22.541,39.2a2.313,2.313,0,0,1,2.154.007l11.036,5.85A2.314,2.314,0,0,0,39.1,42.631M25.667,33.384l-5.556-2.952a1.166,1.166,0,0,0-1.085,0l-5.581,2.9a1.166,1.166,0,0,1-1.686-1.236l1.091-6.2a1.166,1.166,0,0,0-.331-1.033L8.034,20.455a1.165,1.165,0,0,1,.655-1.985l6.23-.878a1.165,1.165,0,0,0,.88-.634l2.809-5.629a1.166,1.166,0,0,1,2.091.009l2.759,5.654a1.165,1.165,0,0,0,.875.641l6.222.932a1.166,1.166,0,0,1,.637,1.991l-4.524,4.371a1.166,1.166,0,0,0-.34,1.03l1.036,6.2a1.165,1.165,0,0,1-1.7,1.221" transform="translate(0 0)" fill="url(#grad1)" />) : (<path id="Trazado_12" data-name="Trazado 12" d="M39.1,42.631l-2.07-12.318a2.314,2.314,0,0,1,.672-2.046l8.974-8.688A2.314,2.314,0,0,0,45.4,15.627L33.05,13.789a2.314,2.314,0,0,1-1.738-1.272L25.822,1.3a2.314,2.314,0,0,0-4.15-.014L16.106,12.466a2.315,2.315,0,0,1-1.747,1.26L1.992,15.48A2.314,2.314,0,0,0,.7,19.423l8.915,8.749a2.314,2.314,0,0,1,.659,2.051l-2.153,12.3a2.314,2.314,0,0,0,3.349,2.451L22.541,39.2a2.313,2.313,0,0,1,2.154.007l11.036,5.85A2.314,2.314,0,0,0,39.1,42.631M25.667,33.384l-5.556-2.952a1.166,1.166,0,0,0-1.085,0l-5.581,2.9a1.166,1.166,0,0,1-1.686-1.236l1.091-6.2a1.166,1.166,0,0,0-.331-1.033L8.034,20.455a1.165,1.165,0,0,1,.655-1.985l6.23-.878a1.165,1.165,0,0,0,.88-.634l2.809-5.629a1.166,1.166,0,0,1,2.091.009l2.759,5.654a1.165,1.165,0,0,0,.875.641l6.222.932a1.166,1.166,0,0,1,.637,1.991l-4.524,4.371a1.166,1.166,0,0,0-.34,1.03l1.036,6.2a1.165,1.165,0,0,1-1.7,1.221" transform="translate(0 0)" fill="#fff" />)}

                </g>
            </svg>

        </LikeInfluencerContainer>
    )
}